module.exports = "<a ui-sref=\"contabilidad.polizasexternas()\">\r\n  <app-launcher color=\"#009688\">\r\n    <icon>Pe</icon>\r\n    <label>Pólizas externas</label>\r\n  </app-launcher>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/contabilidad/polizasexternas/components/launcher/template.html
// module id = 1872
// module chunks = 0